import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { PermisosService } from "src/app/services/permisos.service";
import Swal from "sweetalert2";
import { LoginService } from "./login.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private service: LoginService,
    private permisosServ: PermisosService
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }
  buildForm() {
    this.form = this.fb.group({
      noEmployeeOrEmail: ["", Validators.required],
      password: ["", Validators.required],
    });
  }

  login() {
    if (this.form.valid) {
      const data = this.form.value;
      this.loading = true;
      setTimeout(() => {
        this.service.getToken(data.noEmployeeOrEmail, data.password).subscribe(
          (successData) => {
            this.loading = false;
            // eslint-disable-next-line @typescript-eslint/dot-notation
            localStorage.setItem("access_token", successData["access_token"]);
            localStorage.setItem("log_type", "lg");
            localStorage.setItem("permisos", successData["permisos"]);
            localStorage.setItem("in", successData["in"]);
            localStorage.setItem("co", successData["co"]);
            this.permisosServ.setPermisos(successData["permisos"]);
            this.router.navigate(["/admin"]);
          },
          (err: HttpErrorResponse) => {
            this.loading = false;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.error.error_description ?? "Contacte a soporte",
            });
          }
        );
      }, 1000);
    }
  }
}
